import React, { FC } from 'react';
import { styled } from '@mui/material';
import { Box, Card, CardContent, CardHeader, Link } from '@mui/material';
import { Grid } from '@mui/system';
import { isUndefined } from 'lodash';
import { useSelector } from 'react-redux';
import { useFormat } from 'common/hooks';
import { REGULAR_UNIT } from 'components/FeaturedSpreadsheet/constants';
import { SubscriptionExpiredBox } from 'dashboard409a/components/SubscriptionExpiredBox';
import { TrendsDetail } from 'dashboard409a/components/TrendsDetail';
import { ITrendsDetailProps } from 'dashboard409a/components/TrendsDetail/types';
import { IValuationState } from 'dashboard409a/states/features/valuation';
import { RootStateType } from 'dashboard409a/states/store';
import { ValuationTrendCardsProps } from './types';
import { ReportsCardHeader } from '../ReportsCardHeader';
import { ValuationTrendProps } from '../ValuationTrend/types';
import ValuationTrend from '../ValuationTrend/ValuationTrend';

const PREFIX = 'ValuationTrendCards';

const classes = {
  root: `${PREFIX}-root`,
  link: `${PREFIX}-link`,
  boxTrends: `${PREFIX}-boxTrends`,
};

const StyledGrid = styled(Grid)(() => ({
  [`& .${classes.root}`]: {
    marginBottom: '2%',
    boxShadow: 'none',
  },

  [`& .${classes.link}`]: {
    display: 'inline',
    cursor: 'pointer',
  },

  [`& .${classes.boxTrends}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '2%',
  },
}));

const ValuationTrendCards: FC<ValuationTrendCardsProps> = ({ showTrendsDetails, displayTable }) => {
  const { currentCompany } = useSelector((state: RootStateType) => state.global);
  const { loading, allValuationScalarOpinion } = useSelector<RootStateType, IValuationState>(state => state.valuation);
  const [format, formatDispatch] = useFormat({ units: REGULAR_UNIT });

  const subscriptionIsActive = currentCompany?.is_active;
  const displayExpired = !isUndefined(subscriptionIsActive) && subscriptionIsActive === false;

  const valuationTrendProps: ValuationTrendProps = {
    data: allValuationScalarOpinion,
    isLoading: loading,
  };
  const trendsDetailProps: ITrendsDetailProps = {
    data: allValuationScalarOpinion,
    isLoading: loading,
    format,
    formatDispatch,
  };

  return (
    <StyledGrid size={{ xs: 12, lg: 6 }}>
      <Card className={classes.root}>
        <CardHeader title={<ReportsCardHeader title="Valuation Trend" />} disableTypography />
        <CardContent>
          {displayExpired ? <SubscriptionExpiredBox /> : <ValuationTrend {...valuationTrendProps} />}
          <Box className={classes.boxTrends}>
            <Link
              id="show-valuation-methods-link"
              onClick={() => displayTable('ValuationTrends')}
              className={classes.link}
              variant="body2">
              {`${showTrendsDetails ? 'Hide' : 'Show'} Trends Details`}
            </Link>
          </Box>
        </CardContent>
      </Card>
      {showTrendsDetails ? (
        <Card>{displayExpired ? <SubscriptionExpiredBox /> : <TrendsDetail {...trendsDetailProps} />}</Card>
      ) : null}
    </StyledGrid>
  );
};

export default ValuationTrendCards;
